import { render, staticRenderFns } from "./PromotionPrintout.vue?vue&type=template&id=38ee9d6d&scoped=true"
import script from "./PromotionPrintout.vue?vue&type=script&lang=js"
export * from "./PromotionPrintout.vue?vue&type=script&lang=js"
import style0 from "./PromotionPrintout.vue?vue&type=style&index=0&id=38ee9d6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ee9d6d",
  null
  
)

export default component.exports